module.exports = __webpack_public_path__ + "img/default_user_avatar.de12c91f.svg";